import {
  ChevronDoubleLeft,
  ChevronDoubleRight,
  ChevronLeft,
  ChevronRight,
} from "react-bootstrap-icons";
import PaginationButton from "./PaginationButton";

export default function Pagination({
  navigate,
  currentPage,
  totalPages,
  totalItemCount,
  itemsPerPage,
  showPageCount = false,
}: {
  navigate: (page: number) => void;
  currentPage: number;
  totalPages: number;
  totalItemCount: number;
  itemsPerPage: number;
  showPageCount?: boolean;
}) {
  const starting = itemsPerPage - 1;
  const min = currentPage * itemsPerPage - starting;
  const max =
    currentPage * itemsPerPage > totalItemCount
      ? totalItemCount
      : currentPage * itemsPerPage;

  return (
    <div className="d-flex align-items-center">
      <div className="small me-2">
        {showPageCount ? (
          <div>
            Page {currentPage} of {totalPages}
          </div>
        ) : (
          <div>
            {min}-{max} of {totalItemCount}
          </div>
        )}
      </div>

      <PaginationButton
        onClick={() =>
          currentPage - 10 < 1 ? navigate(1) : navigate(currentPage - 10)
        }
        disabled={currentPage === 1}
      >
        <ChevronDoubleLeft />
      </PaginationButton>
      <PaginationButton
        onClick={() => navigate(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <ChevronLeft />
      </PaginationButton>
      <PaginationButton
        onClick={() => navigate(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <ChevronRight />
      </PaginationButton>
      <PaginationButton
        onClick={() =>
          currentPage + 10 > totalPages
            ? navigate(totalPages)
            : navigate(currentPage + 10)
        }
        disabled={currentPage === totalPages}
      >
        <ChevronDoubleRight />
      </PaginationButton>
    </div>
  );
}
